var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartSuggestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 1.378a.72.72 0 0 1 .923.923l-4.324 11.891a.72.72 0 0 1-1.186.264l-2.66-2.66.157.09 4.482-3.762-2.165-1.25 3.766-3.023-.65-.375L5.83 6.24l1.949 1.125-3.333 2.423-2.9-2.9a.72.72 0 0 1 .169-1.144l.094-.042z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartSuggestion);
export default __webpack_public_path__ + "static/media/smart-suggestion.13f0d2dc7f0513808c411e29b3067280.svg";
export { ForwardRef as ReactComponent };